import { render, staticRenderFns } from "./dashboard-list.vue?vue&type=template&id=7275ee55&"
import script from "./dashboard-list.vue?vue&type=script&lang=js&"
export * from "./dashboard-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports